import { render, staticRenderFns } from "./Shake.vue?vue&type=template&id=2da14eaa&scoped=true"
import script from "./Shake.vue?vue&type=script&lang=js"
export * from "./Shake.vue?vue&type=script&lang=js"
import style0 from "./Shake.vue?vue&type=style&index=0&id=2da14eaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da14eaa",
  null
  
)

export default component.exports